import React from "react";
import { array, string } from "prop-types";

import "./organism1.m.css";
import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";

const Organism1 = ({ stories, className = "" }) => (
  <div styleName="base" className={className}>
    {stories &&
      stories.map(({ story }, index) => (
        <CustomStoryCard4
          key={index}
          story={story}
          aspectRatio={[4, 3]}
          imageType="image4x3"
          showStoryMetaInfo={true}
          showMetaDataForDesktop={global.deviceWidth > 1263}
          isExcerpt={false}
          updatedFont={true}
          src="nine-stories"
        />
      ))}
  </div>
);

Organism1.propTypes = {
  stories: array,
  className: string,
};

export default Organism1;
